import React from 'react';
import { FormattedMessage } from 'react-intl';

export const errorMessage = (
    <FormattedMessage
        id="dbl.sharedModalCompents.errorMessage"
        defaultMessage="An error occurred while processing your request. Please try again later."
    />
);

export const loadingMessage = (
    <FormattedMessage id="dbl.sharedModalCompents.loadingMessage" defaultMessage="Loading..." />
);

export const invalidCharacterErrorMessage = (
    <FormattedMessage
        id="dbl.sharedModalCompents.invalidCharacterErrorMessage"
        defaultMessage="Your message could not be sent because it contains unsupported characters. Please remove any special characters and try again."
    />
);
